import app from "../../../scripts/app";
import template from "./price-estimator-banner.jade";
import { trackEstimatorBannerButton } from './tracking';

app.component("priceEstimatorBanner", {
  template,
  bindings: {
    ad: "=",
    categoryInfo: "="
  },
  controller: [
    '$scope', 'apiService', 'deviceService',
    function($scope, apiService, deviceService) {
      this.isMobile = deviceService.isMobile;
      const getHouseId = (address = []) => {
        const house = address.find(item => item.type === 'house');
        return house ? house.id : void 0;
      };
      const isFlatRent = this.categoryInfo.dealType === "rent";

      this.bannerTitle = isFlatRent ? "За сколько можно сдать эту квартиру?" : "Сколько стоит эта квартира?";
      this.bannerText = isFlatRent
        ? "Поможем оценить ставку аренды квартиры за одну минуту!"
        : "Поможем оценить рыночную стоимость квартиры за одну минуту!";

      this.trackEvent = () => {
        trackEstimatorBannerButton();
      };

      this.queryString = "";

      const updateUrl = () => {
        const houseId = getHouseId(this.ad.geo.address);
        const hasRequiredParams = this.ad && Boolean(houseId) && Boolean(this.ad.roomsCount) && Boolean(this.ad.totalArea) && this.ad.roomsCount <= 4;

        if (hasRequiredParams) {
          apiService.getValuationEstimate(houseId, this.ad.totalArea, this.ad.roomsCount)
            .then((result) => {
              if (result && result.data) {
                this.hasSaleData = Boolean(result.data.sale);
                this.hasRentData = Boolean(result.data.rent);
                this.showEstimationBlock = this.hasSaleData || this.hasRentData;
                this.queryString = `?address=${encodeURIComponent(this.ad.geo.userInput)}&roomsCount=${this.ad.roomsCount}&totalArea=${this.ad.totalArea}`;
              }
            })
            .catch((error) => {
              this.showEstimationBlock = false;
            });
        }
      };

      this.showEstimationBlock = false;

      $scope.$watchGroup(
        [() => this.ad.roomsCount, () => this.ad.totalArea, () => this.ad.geo.address],
        updateUrl
      );
    }
  ]
});
